module.exports = __webpack_public_path__ + "img/cover_220.1b97948c.webp";